class DesignDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.configure(event.detail))
    document.addEventListener('design-type-did-change', (event) => this.configure(event.detail)) 
    document.addEventListener('use-load-combo-did-change', (event) => this.configureLoadCombinationTable(event.detail))
    document.addEventListener('use-lambda-or-cd-did-change', (event) => this.configureLoadCombinationTable(event.detail))
  }

  configure(project) {
    document.getElementById('modal-design-dialog-label').innerHTML = `Design Specification - ${project.designTypeStr}`
    if(project.isWood || project.isNorthAmericanSteel || project.isEngineeredLumber) {
        document.getElementById('design-available-warning').classList.add('d-none')
        document.getElementById('lrfd-combinations-button').classList.remove('d-none')
        document.getElementById('asd-combinations-button').classList.remove('d-none')
        if(project.isLRFD) {
            document.getElementById('lrfd-combinations-button').click()
        } else if(project.isASD) {
            document.getElementById('asd-combinations-button').click()
        } else {
            document.getElementById('no-combinations-button').click()
        }
    } else {
        document.getElementById('design-available-warning').classList.remove('d-none')
        document.getElementById('lrfd-combinations-button').classList.add('d-none')
        document.getElementById('asd-combinations-button').classList.add('d-none')
        document.getElementById('design-dialog-warning-text').innerHTML = `Only Basic Design is available for ${project.material['Type']} shapes.`
        document.getElementById('no-combinations-button').click()
    }
    this.configureDeflectionLimits(project)
    this.configureLoadCombinationTableHeader(project)
    this.configureLoadCombinationTable(project)
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-design-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5" id="modal-design-dialog-label">Design Specifications</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body modal-body-shadow">
            <div class="panel panel-warning d-none" id="design-available-warning">
              <div class="panel-heading" id="design-dialog-warning-text"></div>
            </div>

            <div class="text-center d-flex justify-content-center">
              
              <ul class="nav nav-pills selector-nav-pills mb-3" role="tablist">
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link active show" id="lrfd-combinations-button" data-bs-toggle="tab">
                    LRFD
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="asd-combinations-button" data-bs-toggle="tab">
                    ASD
                  </button>
                </li>
                <li class="nav-item px-1" role="presentation">
                  <button type="button" role="tab" class="nav-link selector-nav-link" id="no-combinations-button" data-bs-toggle="tab">
                    Basic Design
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div class="modal-body">
            <div class="card my-2">
              <div class="card-body">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th colspan=3>Deflection Limits</th>
                    </tr>
                  </thead>
                  <tr>
                    <td>Live Load Deflection Limit (LL):</td>
                    <td>L / <input style='width:100px;' 
                        id='live-load-deflection-limit-input' onchange='onDeflectionLimitChanged();' 
                        type='number' value='360' />
                    </td>
                    <td><i>L + (Lr or S)</i></td>
                  </tr>
                  <tr>
                    <td>Dead Load + Live Limit:</td>
                    <td>L / <input style='width:100px;' 
                        id='dead-plus-live-load-deflection-limit-input' onchange='onDeflectionLimitChanged();'
                        type='number' value='360' />
                    </td>
                    <td><i>D+L</i></td>
                  </tr>
                  <tr>
                    <td>Snow or Wind Limit:</td>
                    <td>L / <input style='width:100px;' 
                        id='snow-or-wind-load-deflection-limit-input' onchange='onDeflectionLimitChanged();'
                        type='number' value='360' />
                    </td>
                    <td><i>S or W</i></td>
                  </tr>
                  <tr>
                    <td>Total Load Deflection Limit (TL):</td>
                    <td>L / <input style='width:100px;' 
                        id='total-load-deflection-limit-input' onchange='onDeflectionLimitChanged();' 
                        type='number' value='240' />
                    </td>
                    <td><i>D+L+S+R+W+H</i></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="card">
              
              <div class="m-2">

                <span>
                  <input class="form-check-input" type="checkbox" id="use-load-combo-equations">
                </span>
                <span id="load-combination-label"></span>
                <span>
                  <i class="fa fa-question-circle text-blue" data-bs-toggle="tooltip" data-bs-placement="right" 
                    title="Click individual load cases below to exlcude them from your design.">
                  </i>
                </span>

                <span class="mx-4" id="lambda-or-cd-toggle">
                  <span>
                    <input class="form-check-input" type="checkbox" value="" id="use-lambda-or-cd">
                  </span>
                  <span id="lambda-or-cd-label">Use &lambda;</span>
                  <i class="fa fa-question-circle text-blue" data-bs-toggle="tooltip" data-bs-placement="right" 
                    title="Load duration factor. Account for wood's ability to carry higher loads for very short durations.">
                  </i>
                </span>
              </div>

              <div class="card-body load-combination-body">
                <div id="load-combination-table"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    `
  }

  configureDeflectionLimits(project) {
    document.getElementById('live-load-deflection-limit-input').value = project.design.liveLoadLimit
    document.getElementById('dead-plus-live-load-deflection-limit-input').value = project.design.deadPlusLiveLoadLimit
    document.getElementById('snow-or-wind-load-deflection-limit-input').value = project.design.snowOrWindLoadLimit
    document.getElementById('total-load-deflection-limit-input').value = project.design.totalLoadLimit
  }

  configureLoadCombinationTableHeader(project) {
    const design = project.design

    if (design.designType === 'None') {
        document.getElementById('use-load-combo-equations').classList.add('d-none')
        document.getElementById('load-combination-label').innerHTML = 'None'
        document.getElementById('lambda-or-cd-toggle').classList.add('d-none')
        return
    }

    let useEquations = design.loadCombination.name !== 'No Combos'

    document.getElementById('use-load-combo-equations').classList.remove('d-none')
    document.getElementById('use-load-combo-equations').checked = useEquations
    document.getElementById('load-combination-label').innerHTML = `Use ${design.designType} Equations`
    
    let showLambdaOrCd = (project.isWood || project.isEngineeredLumber) && (project.isLRFD || project.isASD)

    if(showLambdaOrCd) {
        document.getElementById('lambda-or-cd-label').innerHTML = project.isLRFD ? "Inlcude &lambda;" : "Include C<sub>D</sub>"
        document.getElementById('lambda-or-cd-toggle').classList.remove('d-none')
    } else {
        document.getElementById('lambda-or-cd-toggle').classList.add('d-none')
    }
  }

  lambdaOrCdValue(loadCombination, loadIndex) {
    switch(loadCombination.name) {
        case 'LRFD': return loadCombination.prettyEquations[loadIndex]['lambda']
        case 'ASD' : return loadCombination.prettyEquations[loadIndex]['Cd']
        default: return 1.0
    }
  }

  lambdaOrCdString(project){
      if(project.isWood === false && project.isEngineeredLumber === false) {
        return ""
      }

      const useLambda = document.getElementById('use-lambda-or-cd') ? document.getElementById('use-lambda-or-cd').checked : false
      if(useLambda === false) {
        return ""
      }

      if(project.isLRFD) {
        return "&lambda; (Time Effect Factor)"
          
      } 
      
      if(project.isASD) {
        return "C<sub>D</sub> (Load Duration Factor)"
      }
  }

  configureLambdaOrCdFields(project) {
    if(!project.isWood && !project.isEngineeredLumber) {
        return
    }
    let useLambda = document.getElementById('use-lambda-or-cd') ? document.getElementById('use-lambda-or-cd').checked : false

    useLambda = useLambda && project.design.designType !== 'None'
    project.design.useLambdaOrCd = useLambda

    useLambda ? document.getElementById('lambda-or-cd-header-label').classList.remove('d-none') : document.getElementById('lambda-or-cd-header-label').classList.add('d-none')
    document.getElementById('lambda-or-cd-header-label').innerHTML = this.lambdaOrCdString(project)
    
    for( var i = 0; i < project.design.loadCombination.prettyEquations.length; i++ ) {
      if( project.design.loadCombination.prettyEquations[i]["common"] === false ) {
          continue;
      }
      if( useLambda) {
          document.getElementById(`lambda-or-cd-${i}`).classList.remove('d-none')
      } else {
          document.getElementById(`lambda-or-cd-${i}`).classList.add('d-none')
      }
    }
  }

  configureLoadCombinationTable(project) {
    // Show nicely formated Equations
    const design = project.design;
    if (design.loadCombination === null) { return }

    let str = '<table class="table table-borderless table-hover">'

    let useEquations = design.loadCombination.name !== 'No Combos'
    //let useEquations = (design.loadCombination !== null && design.loadCombination.name !== 'No Combos')
    let comboLabel = design.designType === 'None' || useEquations === false ? "Load Case" : "Combination"
    str += `<tr style="padding: 6px;"><th>${comboLabel}</th><th><span id="lambda-or-cd-header-label">${this.lambdaOrCdString(project)}</span></th></tr>`

    for( let i = 0; i < design.loadCombination.prettyEquations.length; i++ ) {
      if(design.loadCombination.prettyEquations[i]["common"] === false ) {
          continue;
      }
      str += `<tr style="padding: 6px;" class="${design.loadCombination.prettyExclude[i] ? 'text-muted' : ''}" id="load-combination-row-${i}">`
      str += `<td style="padding: 6px;" onclick="toggleLoadCombinationEquation(${i});">`
      str += `<span id="load-combination-check-${i}" class="${design.loadCombination.prettyExclude[i] ? '' : 'fa fa-check'}"> </span> `
      str += `${design.loadCombination.prettyEquations[i]["EQ"]}</td><td style="padding: 6px;">`
      str += `<input class='${project.isWood || project.isEngineeredLumber ? '' : 'd-none'}' id='lambda-or-cd-${i}' type='text' `
      str += `value='${design.loadCombination.lambdaOrCdValue(i)}' onchange='updateLambdaOrCd(${i});'/>`
      str += "</td></tr>"
    }
    str += "</table>"
    document.getElementById('load-combination-table').innerHTML = str

    this.configureLambdaOrCdFields(project)
  }

}

customElements.define('design-dialog-component', DesignDialogComponent)

function openModalDesignDialog() {
  bootstrap.Modal.getOrCreateInstance('#modal-design-dialog').show()
}

window.openModalShapeDialog = openModalShapeDialog

function toggleLoadCombinationEquation(index) {
  document.getElementById(`load-combination-check-${index}`).classList.toggle('fa')
  document.getElementById(`load-combination-check-${index}`).classList.toggle('fa-check')
  document.getElementById(`load-combination-row-${index}`).classList.toggle('text-muted')
  document.dispatchEvent(new CustomEvent('toggle-load-combination-equation', {detail: index}))
}

function onDeflectionLimitChanged() {
  let designLimits = {}
  let id = 'live-load-deflection-limit-input'
  if(validateRequiredInput(id) && validateMinimum(id, 1)) {
    designLimits.liveLoadLimit = parseInt(document.getElementById(id).value)
  } else { 
      return
  }
  id = 'dead-plus-live-load-deflection-limit-input'
  if(validateRequiredInput(id) && validateMinimum(id, 1)) {
    designLimits.deadPlusLiveLoadLimit = parseInt(document.getElementById(id).value)
  } else { 
      return
  }
  id = 'snow-or-wind-load-deflection-limit-input'
  if(validateRequiredInput(id) && validateMinimum(id ,1)) {
    designLimits.snowOrWindLoadLimit = parseInt(document.getElementById(id).value)
  } else { 
      return
  }
  id = 'total-load-deflection-limit-input'
  if(validateRequiredInput(id) && validateMinimum(id, 1)) {
    designLimits.totalLoadLimit = parseInt(document.getElementById(id).value)
  } else { 
      return
  }
  document.dispatchEvent(new CustomEvent('design-deflection-limits-changed', {detail: designLimits}))
}